export const appID = {
    'prod': {
        'ca': {
            'general': 'sq0idp-76vXZfW_PoY0eIDrE1pbuQ',
            'windsor': 'sq0idp-pzxugO-V2ufFNonw-mm63A'
        },
        'us': {
            'general': 'sq0idp-mmBUhNpNa0t5fHDJRVPDlA',
            'nashville': 'sq0idp-AGkUmGj973RteTRLsBY2mA',
            'frisco': 'sq0idp-EkexFHgDgURBVmkthebwdQ',
            'waldorf': 'sq0idp-AiIRU4QIHps-cOqGiT4I7A'
        },
        'uk': {
            'wembley, london': 'sq0idp-yhei2Eg72CofXgD2IA5CCw',
            'croydon': 'sq0idp-yhei2Eg72CofXgD2IA5CCw'
        }
    },
    'dev': {
        'ca': {
            'general': 'sandbox-sq0idb-r5C1zqzuoSKiu32AHq-WUA',
            'windsor': 'sandbox-sq0idb-r5C1zqzuoSKiu32AHq-WUA'
        },
        'us': {
            'general': 'sandbox-sq0idb-r5C1zqzuoSKiu32AHq-WUA',
            'nashville': 'sandbox-sq0idb-r5C1zqzuoSKiu32AHq-WUA',
            'frisco': 'sandbox-sq0idb-pzmztR9cVG1UPTcdSGkfFQ',
            'waldorf': 'sandbox-sq0idb-r5C1zqzuoSKiu32AHq-WUA'
            // 'waldorf': 'sandbox-sq0idb-PVMtqMG5FWkfJSrEXh4RSA'
        },
        'uk': {
            'wembley, london': 'sandbox-sq0idb-r5C1zqzuoSKiu32AHq-WUA',
            'croydon': 'sandbox-sq0idb-r5C1zqzuoSKiu32AHq-WUA'
        }
    }
};

export const zipString = {
    'ca': 'Postal Code',
    'us': 'ZIP Code',
    'uk': 'ZIP Code'
};

export const locationID = {
    'default_us'                : '5QEPF69Y0DBEN',
    'default_ca'                : 'ZB8691NMNJPPT',
    'default_uk'                : '7VXK793WB2X9X',
    'atlanta'                   : 'D46AMSBCBBD7M',
    'alexandria'                : 'L4PTP97RVZWZB',
    'aurora'                    : '7WFCN2JZC1XR9',
    'charlotte'                 : 'DADTNKWM28TT4',
    'chicago (lake view)'       : 'WK3CMPJMQJQSN',
    'chicago (west loop)'       : '2ZPZHTJ8PE4CY',
    'chicago'                   : '2ZPZHTJ8PE4CY',
    'colorado springs'          : 'Q0B0MYAERYCZH',
    'dallas'                    : 'QKVPXWYQMN1HE',
    'denver'                    : '3B69CN8RGSR2J',
    'denver downtown'           : 'QZ09DN1GXGDDB',
    'fairfax'                   : '7NQTHRJDAJXSC',
    'fort worth'                : 'K84PHA5Q3CB2Q',
    'fresno'                    : 'TAT4N8G0ESW9N',
    'frisco'                    : 'LVA7XAJQQ1SH3',
    'greensboro'                : '84VH72MTMZCMM',
    'huntsville'                : 'NV0JSD0YSQEX5',
    'indianapolis'              : '5R3111CQ9CYDK',
    'jacksonville'              : 'B0KJBMD6RFAV2',
    'long beach'                : 'QPV00M8BFPVCN',
    'matawan'                   : 'AYFGS0KAWABM1',
    'minneapolis'               : 'V0MR2VBEZ5X02',
    'minneapolis (city center)' : 'HA8EBRDFNB1S3',
    'new rochelle'              : '4XMZWWW9FZEQ0',
    'nashville'                 : 'LFKNAYDJYM98E',
    'north indianapolis'        : 'BQA1WJW22YAFP',
    'oklahoma'                  : '1AAX88DRAV7TP',
    'richmond'                  : 'MST1XDPH7NKPZ',
    'rochester'                 : 'F2ENRA5N9Y10P',
    'sacramento'                : '309MKXTX8R6BB',
    'san diego'                 : 'EKHAERP7D243G',
    'san francisco'             : '7A0EEMGXR8JJ8',
    'spanish fort'              : 'WQVAWYHMKH9K5',
    'syracuse'                  : 'XPFHH3N465AKX',
    'washington'                : '43SM59M528DYS',
    'burlington'                : '7ASC2JC8VFP85',
    'kitchener'                 : 'ASVDK2WKZXBK0',
    'mississauga'               : 'DSZFK1ZHHBXYA',
    'ottawa'                    : '2CT9QHFNKWEGE',
    'surrey'                    : '5JBCYQRWFDXFS',
    'toronto'                   : '3RXMWG7JBTX1W',
    'vaughan'                   : 'CQZ1FPMGTCJQH',
    'waterloo'                  : 'RR90859GGW96P',
    'windsor'                   : 'CCFH2BXVQDPPZ',
    'winnipeg'                  : 'E2A30JB7QBHSG',
    'wembley, london'           : 'Q29PHP0YN19PB',
    'croydon'                   : 'L6PJ64GJJT6RQ',
    'waldorf'                   : 'LXATM77NYZ382'
}
